import Constants from "../../../../constants/Index";
import { IPayloadProps } from "../../../../@types/Onboarding/IPayload";

export const ONBOARDING_V2_ACTIVE_FARM = "@pastejo-onboarding/v2/active-farm";
export const ONBOARDING_V2_COMPLETED_FARMS = "@pastejo-onboarding/v2/completed-farms";

export function persistPayload(payload: any) {
  localStorage.setItem(Constants.LOCALSTORAGE_PAYLOAD, JSON.stringify(payload));
}

export function getActiveFarmId(payload?: Partial<IPayloadProps>) {
  const stored = localStorage.getItem(ONBOARDING_V2_ACTIVE_FARM);
  if (stored) return stored;
  return payload?.farms?.[0]?.uuid || "";
}

export function setActiveFarmId(farmId: string) {
  localStorage.setItem(ONBOARDING_V2_ACTIVE_FARM, farmId);
}

export function getCompletedFarmIds() {
  try {
    return JSON.parse(localStorage.getItem(ONBOARDING_V2_COMPLETED_FARMS) || "[]") as string[];
  } catch {
    return [];
  }
}

export function markFarmCompleted(farmId: string) {
  const completed = getCompletedFarmIds();
  const next = completed.includes(farmId) ? completed : [...completed, farmId];
  localStorage.setItem(ONBOARDING_V2_COMPLETED_FARMS, JSON.stringify(next));
  return next;
}

export function areAllFarmsCompleted(farmIds: string[]) {
  const completed = getCompletedFarmIds();
  return farmIds.length > 0 && farmIds.every((farmId) => completed.includes(farmId));
}

export function getNextPendingFarmId(farmIds: string[]) {
  const completed = getCompletedFarmIds();
  return farmIds.find((farmId) => !completed.includes(farmId)) || "";
}
